/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { authSelectors } from '../../../../app/auth/auth.selectors';
import { storeFilteredMeetingsSimple } from '../../../../app/page/page-storage/meetings-simple/meetings-simple.actions';
import { meetingsSimplePageSelectors } from '../../../../app/page/page-storage/meetings-simple/meetings-simple.selectors';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import { useSelect, useSelectWithParams } from '../../../../utils/selector.utils';
import { MeetingBadge } from './MeetingBadge';
import { CircularAvatar } from '../../common/CustomAvatar';
import { CreateMeetingButton } from '../../common/CreateMeetingButton';

export const UserBar = () => {
  const dispatch = useDispatch();
  const userId = useSelect(authSelectors.selectLoggedUser);
  const isAdmin = useSelect(authSelectors.selectUserIsAdmin);
  const user = useSelectWithParams(userSelectors.selectResourceById, userId ? userId : '');

  const meetingIds = useSelect(meetingsSimplePageSelectors.selectMeetingsSimple);

  const [meetingFilter, setMeetingFilter] = useState<boolean[]>([]);
  useEffect(() => {
    setMeetingFilter(Array(meetingIds.length).fill(false));
  }, [meetingIds]);

  const setToggledMeeting = useCallback(
    (index) => {
      const newMeetingFilter = [...meetingFilter];
      newMeetingFilter[index] = !newMeetingFilter[index];
      setMeetingFilter(newMeetingFilter);

      const filteredMeetingIds = meetingIds.filter((meetingId, index) => !newMeetingFilter[index]);
      if (userId && filteredMeetingIds) {
        //dispatch(filterTaskForUserByMeetingIds(userId, filteredMeetingIds));
        const newFilteredMeetings = meetingIds.filter((id) => !filteredMeetingIds.includes(id));
        dispatch(storeFilteredMeetingsSimple(newFilteredMeetings));
      }
    },
    [dispatch, meetingFilter, meetingIds, userId],
  );

  const currentHour = Number(moment().format('HH'));
  let greetingString = '';
  if (currentHour >= 6 && currentHour < 12) {
    greetingString = 'Good Morning';
  } else if (currentHour >= 12 && currentHour < 18) {
    greetingString = 'Good Afternoon';
  } else {
    greetingString = 'Good Evening';
  }

  return (
    user && (
      <div className="row mb-2">
        <div className="col-12">
          <div className="panel flex aic py-1 px-2">
            <div className="big-avatar mr-2">
              <CircularAvatar src={user.image} title={`${user.firstName} ${user.lastName}`} size="60" />
            </div>
            <h2 className="mr-3 bold">
              {greetingString}, {user.firstName}!
            </h2>
            <label className="f-1">show/hide meetings:</label>
            <div className="show-hide-teams-container">
              <div className="show-hide-teams">
                {meetingIds.map((meetingId, index) => (
                  <MeetingBadge
                    key={meetingId}
                    meetingId={meetingId}
                    toggled={meetingFilter[index]}
                    setToggled={() => setToggledMeeting(index)}
                  />
                ))}
              </div>
            </div>
            <div className="ml-auto flex">
              {/* <a className="btn btn-md darkGray-bg popup_button" title="Add a Topic" onClick={openTaskFormDialog}>
                <i className="icon-plus mr-1"></i> Add a Topic
              </a> */}
              {/*
              <a className="btn btn-md darkGray-bg popup_button" data-popup="upload_file_popup" title="Upload a File">
                <img alt="" className="img-fluid mr-1" /> Upload a File
              </a>*/}
              {isAdmin && <CreateMeetingButton label="Create New Meeting" />}
            </div>
          </div>
        </div>
      </div>
    )
  );
};
